module.exports = __webpack_public_path__ + "media/images/countryrect/es-c5812f0634c96dbba02f7373f4a8d312.svg";